/** @format */
'use client';
import useAxios from '@/hooks/useAxios.hook';
import { RootState } from '@/redux/store';
import { endPoint, itemsOf } from '@/utils';
import { useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';

const useSearchList = (queryString: string) => {
  const [initialState, setInitialState] = useState({
    limit: 4,
    skip: 0,
    refreshing: false,
    data: [],
    hasMore: true,
  });
  const { limit, skip, refreshing, data, hasMore } = initialState;
  const { fetchData, loading } = useAxios(true);
  const updateState = (newState: any) => {
    setInitialState((prevState) => ({
      ...prevState,
      ...newState,
    }));
  };
  const location = useSelector((state: RootState) => state.location);
  const coordinates = [location?.lng, location?.lat];

  const debounceTimeout = useRef<NodeJS.Timeout | null>(null);

  const fetchSearchData = async ({
    limit = 10,
    skip = 0,
  }: {
    limit?: number;
    skip: number;
  }) => {
    if (queryString.length >= 3) {
      const res = await fetchData({
        url: endPoint.FETCH_SEARCH_EVENTS,
        params: {
          // limit,
          // skip,
          // lat: '20.529687',
          // lng: '84.433413',
        },
        method: 'POST',
        data: { queryString, coordinates },
        loading,
      });

      const found = itemsOf<never>(res?.data);
      updateState({
        data: found,
        hasMore: found.length >= limit,
      });
    }
  };
  const loadMore = async () => {
    if (hasMore && data?.length) {
      updateState({
        refreshing: true,
      });
      const res = await fetchData({
        url: endPoint.FETCH_SEARCH_EVENTS,
        params: {
          limit,
          skip,
        },
        method: 'POST',
        data: { queryString },
        loading: false,
      });
      const more = itemsOf<never>(res?.data);
      updateState({
        refreshing: false,
        skip: skip + 10,
        hasMore: more.length >= limit,
        data: [...data, ...more],
      });
    }
  };
  useEffect(() => {
    fetchSearchData({ limit: 4, skip: 0 });
  }, [queryString, location]);

  return {
    loading,
    data,
    refreshing,
    hasMore,
    loadMore,
    skip,
  };
};

export default useSearchList;
